import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

interface Props {
  name: string;
  onAccept(): void;
  onRefuse(): void;
}

export function TradeInviteGump({ name, onAccept, onRefuse }: Props) {
  useFechar(onRefuse, { modal: true });

  return (
    <div className="modal" role="presentation" onClick={onRefuse}>
      <div role="dialog" aria-modal="true" aria-labelledby="trade-invite-title" onClick={e => e.stopPropagation()}>
        <Gump
          title={t('troca.titulo')}
          action={
            <button type="button" className="btn btn--tiny btn--ghost" onClick={onRefuse} aria-label={t('comum.fechar')}>
              ×
            </button>
          }
        >
          <div className="stack">
            <p id="trade-invite-title">{t('troca.invited', { nome: name })}</p>
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onRefuse}>{t('comum.recusar')}</button>
              <button type="button" className="btn btn--primary" onClick={onAccept}>{t('comum.aceitar')}</button>
            </div>
          </div>
        </Gump>
      </div>
    </div>
  );
}
